export default __webpack_public_path__ + "static/about-hero-836b1005d82f68bd2d5a2b05a1d7c315.png";